import { useSelector } from 'react-redux';

import {
  selectAuthMethod,
  selectAuthSecret,
  selectDhEncryptionKeys,
} from '@main/privacy-center/src/containers/App/selectors';
import type { DecryptResponse, MakeDhEncrypted } from '@main/sm-browser';
import { createDhPayloadHelpers } from '@main/sm-browser';

/**
 * This hooks creates two functions:
 *
 * 1. a function that takes in some data to be signed and dhEncrypts it
 * 2. a function that can decode a response to that original dhEncrypted request
 *
 * @returns Hook functions described above
 */
export function useDiffieHellman(): [
  // createDhPayload, takes in the payload to sign. This is undefined if the user
  // has tried to establish sombra channel and had that fail and thus cannot establish a dh channel
  undefined | MakeDhEncrypted,
  // when the request responses with a decryption context, decrypt it
  DecryptResponse,
] {
  const authSecret = useSelector(selectAuthSecret);
  const authMethod = useSelector(selectAuthMethod);
  const dhEncryptionKeys = useSelector(selectDhEncryptionKeys);
  const [createDhPayload, decryptPayload] = createDhPayloadHelpers({
    authMethod,
    authSecret,
    dhEncryptionKeys,
  });

  return [createDhPayload, decryptPayload];
}
